var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.734 2.86c-.28-1.126-1.172-2.016-2.25-2.297C21.47 0 13.5 0 13.5 0S5.484 0 3.469.563C2.39.843 1.5 1.734 1.219 2.858.656 4.83.656 9.047.656 9.047s0 4.172.563 6.187a3.127 3.127 0 002.25 2.25C5.484 18 13.5 18 13.5 18s7.969 0 9.984-.516a3.127 3.127 0 002.25-2.25c.563-2.015.563-6.187.563-6.187s0-4.219-.563-6.188zm-14.859 9.984V5.25l6.656 3.797-6.656 3.797z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b81fb081.svg";
export { ForwardRef as ReactComponent };